import 'css-chunk:src/app/containers/Members/MemberDrawer/NewMemberDrawer.scss';export default {
  "content": "_content_1yklw_1",
  "memberDetailsDrawer": "_memberDetailsDrawer_1yklw_11"
};